module.exports = __webpack_public_path__ + "static/media/md.af1d5589.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/md.svg
// module id = 2150
// module chunks = 0